import { FavouriteItem } from "app/area/favourite-administration/form/types-store";
import { ComplexValue } from "app/infrastructure/ui/form/types";

export const changeOwners = (favouriteItem: FavouriteItem, newOwners: ComplexValue<number>[]) => {
  const currentOwners = favouriteItem?.owners ?? [];
  const addedOwners = currentOwners.filter(
    owner => !newOwners?.some(newOwner => newOwner.value === owner.value)
  ) ?? [];
  const removedOwners = newOwners?.filter(
    owner => !currentOwners.some(current => current.value === owner.value)
  ) ?? [];
  return { addedOwners, removedOwners };
};
